export const ATTR_VALUES = {
  LOADING: 'Loading'
};
